import { createContext } from "react";
import Rollbar from "rollbar";

// Create context for accessing Rollbar instance
// We initialize with null, but the provider will supply the instance
export const RollbarContext = createContext<Rollbar | null>(null);
